export default __webpack_public_path__ + "static/media/Regulamin.86a2c0e8.pdf";